import { Router, Route, Switch, Redirect } from 'react-router-dom';

import { PrivateRoute } from './Connect/_components';
import { history } from './Connect/_helpers';
import RecoilApp from './Portal/RecoilApp';
import { Login } from './Connect/login';
import { Public } from './Portal/Public/Public';

import 'bootstrap/dist/css/bootstrap.min.css';

export { App };

function App() {
    return (
        <Router history={history}>
            <Switch>
                <PrivateRoute exact path="/portail_V2/" component={RecoilApp} />
                <Route exact path="/portail_V2/downloadDiffusion" component={Public} />
                <Route path="/portail_V2/login" component={Login} />
                <Redirect from="*" to="/portail_V2/" />
            </Switch>
        </Router>
    );
}